import { call, put, takeEvery } from 'redux-saga/effects'
import * as duAnActions from '../ducks/duAnDucks'
import * as duAnApi from '../../api/duAnApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListDuAn({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof duAnApi.getListDuAn> = yield call(duAnApi.getListDuAn, queryString)
    yield put(duAnActions.getListDuAnSuccess(res))
  } catch (error) {
    yield put(duAnActions.getListDuAnFail(error))
  }
}

function* fetchDetailDuAn({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof duAnApi.getDetailDuAn> = yield call(duAnApi.getDetailDuAn, id)
    yield put(duAnActions.getDetailDuAnSuccess(res))
  } catch (error) {
    yield put(duAnActions.getDetailDuAnFail(error))
  }
}

export default function* watchDuAn() {
  yield takeEvery(duAnActions.getListDuAn.toString(), fetchListDuAn)
  yield takeEvery(duAnActions.getDetailDuAn.toString(), fetchDetailDuAn)
} 